<script>
import {
  opusIconsLine,
  opusIconsPicto
} from '@/lego-component/components/element/legoIcon/opusIconPath.js';
import { customImage } from './imagePath.js';
import { dfIcons } from './dfPath.js';
import { prodIcons } from './prodPath.js';
import { h } from 'vue';

export default {
  props: {
    iconType: {
      type: String,
      validator: function (value) {
        return ['line', 'picto', 'custom', 'image', 'df', 'prod'].indexOf(value) !== -1;
      }
    },
    colorReverse: {
      type: Boolean,
      default: false
    },
    withoutPointer: {
      type: Boolean,
      default: false
    }
  },
  render(props) {
    let opusIcons = {};
    let cType = props.iconType || props.type;
    if (cType === 'picto') {
      opusIcons = opusIconsPicto;
    } else if (cType === 'line') {
      opusIcons = opusIconsLine;
    } else if (cType === 'image') {
      opusIcons = customImage;
    } else if (cType === 'df') {
      opusIcons = dfIcons;
    } else if (cType === 'prod') {
      opusIcons = prodIcons;
    }

    let cColor = '';
    if (props.primary || props.prim) {
      cColor = 'primary';
    } else if (props.point || props.pnt) {
      cColor = 'point';
    } else if (props.default || props.dft) {
      cColor = 'default';
    } else if (!!props.color || !!props.col) {
      cColor = props.color || props.col;
    }

    let cSize = '';
    if (props.large || props.lg) {
      cSize = 'large';
    } else if (props.medium || props.md) {
      cSize = 'medium';
    } else if (props.small || props.sm) {
      cSize = 'small';
    } else if (props.xsmall || props.xs) {
      cSize = 'xsmall';
    }

    let customSize = props.iconSize || props.size;
    if (typeof customSize === 'number') {
      customSize = customSize + 'px';
    }

    const getChildrenName = (childrens) => {
      if (Array.isArray(childrens) && childrens.length) {
        return getChildrenName(childrens[0].children);
      }
      return childrens;
    };
    const childrenName = props.$slots.default ? getChildrenName(props.$slots.default()) : '';
    const icName = props.icon || childrenName;
    const iconName = icName ? icName.trim() : '';
    const listeners = {};
    for (const key in props.$attrs) {
      if (typeof props.$attrs[key] === 'function') {
        listeners[key] = props.$attrs[key];
      }
    }
    let options = {
      class: [
        'lego-icon',
        cType && 'lego-icon--' + cType,
        cColor && 'lego-icon--' + cColor,
        cSize && 'lego-icon--' + cSize,
        props.spacing && 'lego-icon--spacing',
        Object.keys(listeners).length > 0 && 'lego-icon--event',
        props.colorReverse && 'lego-icon--rev'
      ],
      style: {
        fontSize: customSize,
        color: cColor
      }
    };
    if (props.withoutPointer) {
      options.style.pointerEvents = 'none';
    }
    if (props.$attrs.class) {
      if (Array.isArray(props.$attrs.class)) {
        options.class = options.class.concat(props.$attrs.class);
      }
      if (typeof props.$attrs.class === 'string' || typeof props.$attrs.class === 'object') {
        options.class.push(props.$attrs.class);
      }
    }
    if (props.$attrs.style) {
      options.style = Object.assign(props.$attrs.style, options.style);
    }
    if (opusIcons[iconName] !== undefined) {
      // !!! BE CAREFUL !!! this component uses v-html(innerHTML).
      // So, opusIcons object MUST NOT contain XSS vulnerability.
      options.class.push('opus-icon__' + iconName);
      let svg = opusIcons[iconName];
      if (!props.focusable) {
        svg = svg.replace('<svg ', '<svg focusable="false" ');
      }
      options.innerHTML = svg;
    } else {
      // 1. icon class
      options.class.push('fa-' + iconName);
      // 2. type class
      if (props.brand) {
        options.class.push('fab');
      } else if (props.fab) {
        options.class.push('fab');
      } else if (props.regular) {
        options.class.push('far');
      } /* pro only */ else if (props.far) {
        options.class.push('far');
      } /* pro only */ else if (props.light) {
        options.class.push('fal');
      } /* pro only */ else if (props.fal) {
        options.class.push('fal');
      } /* pro only */ else if (props.old) {
        options.class.push('fa');
      } /* font-awesome 4.0*/ else if (props.fa) {
        options.class.push('fa');
      } /* font-awesome 4.0*/ else {
        options.class.push('fas');
      }
    }

    return h('i', Object.assign({ ...props.$attrs }, options));
  }
};
</script>
<style lang="scss" scoped>
.lego-icon--image {
  :deep svg {
    width: 100%;
    height: 100%;
  }
}

.lego-icon {
  color: #555b68;
}

.lego-icon--event {
  cursor: pointer;
  color: rgba($color--ui01, 0.6);

  &:hover,
  &:active {
    color: rgba($color--ui01, 1);
  }

  &:disabled {
    color: rgba($color--ui01, 0.2);
  }

  &.lego-icon--rev {
    color: rgba($color--ui-white, 0.6);

    &:hover,
    &:active {
      color: rgba($color--ui-white, 1);
    }

    &:disabled {
      color: rgba($color--ui-white, 0.2);
    }
  }
}

.opus-icon__info {
  color: rgba(#2b3851, 0.5);

  &:hover,
  &:active {
    color: rgba(#2b3851, 1);
  }

  &:disabled {
    color: rgba(#2b3851, 0.2);
  }
}
</style>
